module.exports = __webpack_public_path__ + "img/app.0055ea97.png";